import { BillingCycle } from '../enums/entity.enums';

export const BillingCycleData = [
  { label: 'Weekly', value: BillingCycle.WEEKLY.toString() },
  { label: 'Biweekly', value: BillingCycle.BI_WEEKLY.toString() },
  { label: 'Monthly', value: BillingCycle.MONTHLY.toString() },
  { label: 'Quarterly', value: BillingCycle.QUARTERLY.toString() },
  { label: 'Annually', value: BillingCycle.ANNUALLY.toString() },
];
